import Header from "./components/Header";
import Home from "./Home";
import Footer from "./components/Footer";
import { Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import DigitalMarketingStrategy from "./pages/DigitalMarketingStrategy";
import WebsiteSoftwareDevelopment from "./pages/WebsiteSoftwareDevelopment";
import BrandBuilding from "./pages/BrandBuilding";
import Pagenotfound from "./pages/Pagenotfound";
import DataAnalytics from "./pages/DataAnalytics";
import SocialMediaManagement from "./pages/SocialMediaManagement";
import HealthtechSpecificSolutions from "./pages/HealthtechSpecificSolutions";
import SupportAndManagedServices from "./pages/SupportAndManagedServices";
import CloudSolutions from "./pages/CloudSolutions";
import FAQs from "./pages/FAQs";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Blogs from "./pages/blogs";
import BlogsAI from "./pages/ai-transforming-pharmaceutical-industry-2026";
import BlogsDigital from "./pages/digital-transformation-pharma-pharma-companies-need-ai-solutions-today";
import TopDigital from "./pages/top-digital-solutions-every-pharmaceutical-company-implement-2026";
import DataAnalyticsPharma from "./pages/data-analytics-revolutionizing-pharmaceutical-business-growth";
import PharmaServices from "./pages/pharma-services-india-future-ai-powered-healthcare-technology";
import ArtificialTransform from "./pages/artificial-intelligence-transforming-digital-marketing";
import BestSeo from "./pages/what-are-the-best-seo-strategies-to-increase-website-traffic-in-2025";
import WebsiteDevelopmentStrategy from "./pages/every-business-needs-professional-website-development-strategy";
import SeoLead from "./pages/how-seo-services-help-businesses-generate-high-quality-leads";
import TrendsBussiness from "./pages/website-development-trends-every-business-should-know";
import AiTrending from "./pages/ai-vs-traditional-digital-marketing-works-best-2026";
import Test from "./pages/test";
import ScrollToTop from "./pages/ScrollToTop";


function App() {
  return (
    <main>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/services/digital-marketing-strategy" element={<DigitalMarketingStrategy />} />
        <Route path="/services/website-and-software-development" element={<WebsiteSoftwareDevelopment />} />
        <Route path="/services/brand-building" element={<BrandBuilding />} />
        <Route path="/services/data-analytics" element={<DataAnalytics />} />
        <Route path="/services/social-media-management" element={<SocialMediaManagement />} />
        <Route path="/services/healthtech-specific-solutions" element={<HealthtechSpecificSolutions />} />
        <Route path="/services/support-and-managed-services" element={<SupportAndManagedServices />} />
        <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-conditions" element={<Terms />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/ai-transforming-pharmaceutical-industry-2026" element={<BlogsAI />} />
        <Route path="/digital-transformation-pharma-pharma-companies-need-ai-solutions-today" element={<BlogsDigital />} />
        <Route path="/top-digital-solutions-every-pharmaceutical-company-implement-2026" element={<TopDigital />} />
        <Route path="/data-analytics-revolutionizing-pharmaceutical-business-growth" element={<DataAnalyticsPharma />} />
        <Route path="/pharma-services-india-future-ai-powered-healthcare-technology" element={<PharmaServices />} />
        <Route path="/artificial-intelligence-transforming-digital-marketing" element={<ArtificialTransform />} />
        <Route path="/what-are-the-best-seo-strategies-to-increase-website-traffic-in-2025" element={<BestSeo />} />
        <Route path="/every-business-needs-professional-website-development-strategy" element={<WebsiteDevelopmentStrategy />} />
        <Route path="/how-seo-services-help-businesses-generate-high-quality-leads" element={<SeoLead />} />
        <Route path="/website-development-trends-every-business-should-know" element={<TrendsBussiness />} />
         <Route path="/ai-vs-traditional-digital-marketing-works-best-2026" element={<AiTrending />} />
       
         <Route path="/test" element={<Test />} />
        <Route path="*" element={<Pagenotfound title="404 Page" />} />

        {/* Add more routes here */}
      </Routes>
      <Footer />
    </main>
  );
}

export default App;
